export default "__VITE_ASSET__BqquS8Cy__"